<template>
  <div id="contenedor-eliminar-contrato-escalatoria">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Escalatoria </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar la escalatoria? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarEscalatoria"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixContratosEscalatorias from './mixContratosEscalatorias';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarEscalatoriaContrato',
  mixins: [mixContratosEscalatorias],
  props: {
    contratoEscalatoriaEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
